var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThermometer = function SvgThermometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.988a2.484 2.484 0 0 1 2.482 2.482v9.59a4.365 4.365 0 1 1-4.964-.001v-9.59a2.48 2.48 0 0 1 2.481-2.48m0 1.2a1.283 1.283 0 0 0-1.282 1.282v9.919a.6.6 0 0 1-.3.52 3.165 3.165 0 1 0 3.165 0 .6.6 0 0 1-.301-.52v-9.92a1.283 1.283 0 0 0-1.283-1.282"
  })));
};
export default SvgThermometer;